import { css } from '@lyearn/style';

export const inlineBreadcrumbs = css`
  min-width: 0;
  padding: 0;
  border-top: 0;
  background: transparent;
`;
